import { render, staticRenderFns } from "./indexUnbind.vue?vue&type=template&id=bd572c2c"
import script from "./indexUnbind.vue?vue&type=script&lang=js"
export * from "./indexUnbind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports